import CreateProjectOverrideMemberSet from "@app/projects/createProjectOverrideMemberSet";

export const applyPrimaryMembershipBindingChange = (
  overrides: CreateProjectOverrideMemberSet[],
  memberSetId: number | null,
  code: string,
): CreateProjectOverrideMemberSet[] =>
  overrides.map((x) => {
    const filteredCodes = x.primarySpecialtyGroupCodes.filter((c) => c !== code);
    return {
      ...x,
      primarySpecialtyGroupCodes: x.memberSetId === memberSetId ? [...filteredCodes, code] : filteredCodes,
    };
  });

export const applySecondaryMembershipBindingChange = (
  overrides: CreateProjectOverrideMemberSet[],
  memberSetId: number | null,
  code: string,
): CreateProjectOverrideMemberSet[] =>
  overrides.map((x) => {
    const filteredCodes = x.secondarySpecialtyGroupCodes.filter((c) => c !== code);
    return {
      ...x,
      secondarySpecialtyGroupCodes: x.memberSetId === memberSetId ? [...filteredCodes, code] : filteredCodes,
    };
  });
